// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zQQxq{align-items:center;display:flex;gap:1rem;justify-content:space-between}.lGOZg{color:var(--anchore-color-gray-900);font-size:1.4rem;font-weight:700}.pE8l0{flex-shrink:0}.ja9AK{display:flex;flex-direction:column;gap:.25rem}.Vndsv{color:#587795;font-size:.85rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase}:root[data-darkreader-scheme=dark] .Vndsv{color:#9bb6ca}.rnYcK{color:var(--anchore-color-gray-700);display:-webkit-box;font-size:1rem;line-height:1.4;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `zQQxq`,
	"cve": `lGOZg`,
	"indicators": `pE8l0`,
	"description": `ja9AK`,
	"descriptionLabel": `Vndsv`,
	"descriptionText": `rnYcK`
};
module.exports = ___CSS_LOADER_EXPORT___;
